import { SlackSettingsContainerComponent } from './slack-settings-container.component';

export type SlackSettingsContainerComponentT = new (
  ...args: any[]
) => SlackSettingsContainerComponent;

export const SlackSettingsComponentLoader: () => Promise<SlackSettingsContainerComponentT> = () =>
  import('./slack-settings-container.component').then(k => k.SlackSettingsContainerComponent);
